'use client';
import styled from 'styled-components';

export const StyledSimpleCallout = styled.div`
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  padding: ${props => props.theme.spacing(14, 0)};

  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(20, 0)};
  }
`;

export const Inner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1080px;
  text-align: center;
  padding-left: 0px;
  vertical-align: center;
  @media ${props => props.theme.tablet} {
    flex-direction: row;
    flex-wrap: ${props => (props.$alignment ? 'wrap' : 'nowrap')};
    justify-content: space-between;
    text-align: left;
    padding-left: ${props => props.theme.spacing(10)};
  }
`;

export const ImageWrapper = styled.div`
  flex: 0 0 auto;
  padding-right: 0px;
  @media ${props => props.theme.tablet} {
    padding-right: ${props => props.theme.spacing(10)};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  padding: ${props => props.theme.spacing(0, 5)};

  @media ${props => props.theme.tablet} {
    flex: 1 1 auto;
    margin: 0;
  }
`;

export const Body = styled.p`
  ${props => props.theme.typography[props.$typography]};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  margin: ${props => props.theme.spacing(8, 0, 10)};
  max-width: 500px;

  @media ${props => props.theme.tablet} {
    margin: ${props => props.theme.spacing(0, 0, 5)};
  }
`;

export const Description = styled.p`
  ${props => props.theme.typography[props.$typography]};
  ${props => props.theme.fontFamily.base};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  margin-bottom: ${props => props.theme.spacing(8)};

  @media ${props => props.theme.tablet} {
    margin: 0;
  }
`;

export const ButtonContainer = styled.div`
  flex: 0 0 auto;
  width: 100%;
  align-self: stretch;
  display: flex;
  justify-content: ${props => props.theme.getJustifyContent(props.$alignment)};
  box-sizing: border-box;
  padding: ${props => props.theme.spacing(0, 5)};

  @media ${props => props.theme.tablet} {
    ${props =>
      props.$alignment
        ? `
          flex: 1 0 100%;
          width: 100%;
        `
        : `
          width: auto;
        `}
  }
`;
